<!-- Bottone circolare (si vede solo se chat chiusa) -->
<div *ngIf="environment['projectName']"
              [style.--main-color]="environment['MainColor']">
  <button *ngIf="!chatOpen"
          class="btn btn-main rounded-circle shadow chat-btn"
          (click)="toggleChat()">
    <i class="fa-regular fa-comment"></i>
  </button>

  <!-- Finestra chat -->
  <div class="card shadow chat-window"
       [class.open]="chatOpen"
       [class.closed]="!chatOpen">

    <div class="card-header bg-main text-white d-flex justify-content-between align-items-center">
      FortyBot
      <!-- Bottone di chiusura leggermente sistemato per non avere bordi grigi -->
      <button type="button" class="close text-white border-0 bg-transparent" style="font-size: 1.5rem;" (click)="closeChat()">&times;</button>
    </div>

    <div class="card-body chat-body">

      <!-- AI ACT Disclaimer -->
      <div class="ai-disclaimer text-center text-muted mb-3 shadow-sm">
        <small><i class="fas fa-robot me-1"></i> Stai interagendo con un'Intelligenza Artificiale, non con un operatore umano.</small>
      </div>

      <!-- Messaggi -->
      <div *ngFor="let msg of messageList" class="d-flex mb-2"
           [ngClass]="{'justify-content-end': msg.sender === 'user',
                     'justify-content-start': msg.sender === 'bot'}">

        <div class="p-2 rounded shadow-sm msg-bubble"
             [ngClass]="{
             'bg-main text-white user-bubble': msg.sender === 'user',
             'bg-light text-dark bot-bubble': msg.sender === 'bot'
           }">
          <!-- Aggiunto margin-bottom 0 al paragrafo per evitare spazi extra -->
          <p class="mb-0" [innerHTML]="formatMessage(msg.message)"></p>
        </div>
      </div>

      <!-- Animazione puntini quando il bot sta rispondendo -->
      <div *ngIf="isLoading" class="d-flex mb-2 justify-content-start">
        <div class="p-2 rounded shadow-sm bg-light text-dark bot-bubble">
          <span class="typing-dots">
            <span></span><span></span><span></span>
          </span>
        </div>
      </div>

      <!-- Anchor per autoscroll -->
      <div #scrollAnchor></div>
    </div>

    <div class="card-footer">
      <div class="input-group">
        <input type="text"
               class="form-control"
               [(ngModel)]="newMessage"
               placeholder="Scrivi un messaggio..."
               (keyup.enter)="sendMessage()">

        <div class="input-group-append">
          <button class="btn btn-main"
                  type="button"
                  (click)="sendMessage()"
                  [disabled]="isLoading">
            <i class="fas fa-paper-plane"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
